import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";
import image1 from "../../Assets/ExpertisesectionImages/1.svg";
import image2 from "../../Assets/ExpertisesectionImages/2.svg";
import image3 from "../../Assets/ExpertisesectionImages/3.svg";
import image4 from "../../Assets/ExpertisesectionImages/4.svg";
import image5 from "../../Assets/ExpertisesectionImages/5.svg";
import useResponsive from "../../Hooks/useResponsive";

const CELL_SIZE = "389.33px";

const projectImageCellSx = {
  width: { xs: "100%", md: CELL_SIZE },
  maxWidth: CELL_SIZE,
  height: { md: CELL_SIZE },
  aspectRatio: { xs: "1 / 1", md: "unset" },
  mx: "auto",
  p: "24px",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  opacity: 1,
  transform: "rotate(0deg)",
  overflow: "hidden",
};

const FeaturedProjectsSection = () => {
  const { isExtraLarge } = useResponsive();
  const projectImages = [
    { id: 1, src: image1 },
    { id: 2, src: image2 },
    { id: 3, src: image3 },
    { id: 4, src: image4 },
    { id: 5, src: image5 },
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
      },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 60, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        pt: { xs: "40px", lg: "50px" },
        pb: { xs: "40px", lg: "50px" },
        opacity: 1,
        transform: "rotate(0deg)",
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: { xs: "100%", lg: "1312px", xl: "1400px" },
          px: { xs: "24px", md: "48px" },
          mx: "auto",
        }}
      >
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={titleVariants}
        >
          <Box
            sx={{
              width: { xs: "100%", lg: "1216px" },
              minHeight: { xs: "auto", lg: "40px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: { xs: "40px", sm: "48px", lg: "64px" },
              mx: "auto",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: { xs: "28px", lg: "36px" },
                lineHeight: { xs: "32px", lg: "40px" },
                letterSpacing: { xs: "-1.4px", lg: "-1.8px" },
                textAlign: "center",
                verticalAlign: "middle",
                color: "#1C1B1B",
                width: { xs: "auto", lg: "285.23px" },
                height: { xs: "auto", lg: "40px" },
              }}
            >
              Featured Projects
            </Typography>
          </Box>
        </motion.div>

        <Box
          sx={{
            width: { xs: "100%", lg: "1216px", xl: "1312px" },
            mx: "auto",
          }}
        >
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={containerVariants}
          >
            <Grid
              container
              spacing={{ xs: "16px", lg: "32px" }}
              rowSpacing={{ xs: 5, lg: 4 }}
              justifyContent="center"
            >
              {projectImages.map((img, index) => (
                <Grid item xs={12} sm={6} md={4} key={img.id}>
                  <Box
                    component={motion.div}
                    variants={cardVariants}
                    sx={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      position: "relative",
                      transform: "translateZ(0)",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <motion.img
                      src={img.src}
                      alt={`Project ${img.id}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                      whileHover={{ scale: 1.08 }}
                      transition={{ duration: 0.4, ease: "easeOut" }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
};

export default FeaturedProjectsSection;
